module.exports = __webpack_public_path__ + "media/images/icons/envelope-open-c3587ce8727b25e5e16d8ddfb2302134.svg";